import { render } from "./SmartcardListSimple.vue?vue&type=template&id=1bd54644&scoped=true"
import script from "./SmartcardListSimple.vue?vue&type=script&lang=js"
export * from "./SmartcardListSimple.vue?vue&type=script&lang=js"

import "./SmartcardListSimple.vue?vue&type=style&index=0&id=1bd54644&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1bd54644"

export default script